import React, { useEffect, useState } from 'react';

import { useDoc } from '../../hooks/useDoc';
import { FormBase } from '../Interface';
import DocumentPage from './DocumentPage';
import DocumentReports from './DocumentReports';
import ContextMenu from './ContextMenu';

const STORAGE_KEY = 'form-layout-settings';

const getSavedLayout = (docTypeId) => {
  const settings = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  return settings?.Document?.[docTypeId]?.verticalLayout ?? false;
};

export const DocumentMain = ({ docTypeId }) => {
  const docState = useDoc({ docTypeId });

  const [verticalLayout, setVerticalLayout] = useState(() => getSavedLayout(docTypeId));
  const [contextMenu, setContextMenu] = useState({ position: null });

  useEffect(() => {
    setVerticalLayout(getSavedLayout(docTypeId));
  }, [docTypeId]);

  const handleContextMenu = (e) => {
    e.preventDefault();

    setContextMenu({
      position: { mouseX: e.clientX + 2, mouseY: e.clientY - 6 },
    });
  };

  const onLayoutChange = () => {
    const newLayout = !verticalLayout;

    setVerticalLayout(newLayout);

    const settings = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        ...settings,
        Document: {
          ...settings.Document,
          [docTypeId]: {
            ...settings.Document?.[docTypeId],
            verticalLayout: newLayout,
          },
        },
      })
    );

    handleClose();
  };

  const handleClose = () => {
    setContextMenu({ position: null });
  };

  return (
    <>
      <FormBase
        name="Document"
        layoutId={docTypeId}
        leftPanelContent={<DocumentPage docState={docState} onContextMenu={handleContextMenu} />}
        rightPanelContent={!docState.loading && <DocumentReports docState={docState} />}
        verticalLayout={verticalLayout}
      />

      <ContextMenu
        contextMenu={contextMenu}
        handleClose={handleClose}
        verticalLayout={verticalLayout}
        onLayoutChange={onLayoutChange}
      />
    </>
  );
};
